// extracted by mini-css-extract-plugin
export default {"addToCartControl":"sZ-z","giftCard":"tZ-z","btnContainer":"uZ-z","cartButton":"vZ-z","disabled":"wZ-z"};